export default function LoanApplication() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Apply for a Loan
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Start your loan application process today. Our team will review your application and contact you within 24 hours.
          </p>
        </div>

        <div className="bg-teal-50 rounded-xl p-16 text-center">
          <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-time-line text-4xl text-teal-600"></i>
          </div>
          <h3 className="text-3xl font-bold text-gray-900 mb-4">Coming Soon</h3>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Our loan application system is currently being prepared. Please contact us directly for loan inquiries.
          </p>
        </div>
      </div>
    </section>
  );
}